import React from 'react'
import { Logo } from '../components/logo'
import { Text2xl, TextLg, TextMd } from '../components/text'
import { useAppContext } from '../context/appContext'
import { NavLink } from './topBar'

export const BottomInfo = ({ className="", style={} }) => {
  const { routing } = useAppContext();
  const { navigate, baseUrl } = routing;

  return (
    <div
      className={`bottom-info w-full text-white bg-gradient gap-6 p-9 pb-0 mt-auto flex flex-col justify-center items-center ${className}`}
      style={style}
    >
      <TextLg
        onClick={()=>{
          navigate(baseUrl);
        }}
      >
        <Logo className='p-3 px-6'/>
      </TextLg>
      

      <TextMd className='flex flex-wrap gap-2 lg:gap-6 lg:gap-x-12 justify-center text-gray-400 font-semibold select-none *:p-3 sm:*:px-6'>
        <NavLink path={baseUrl}>Home</NavLink>
        <NavLink path="/data-analytics">Data Analytics</NavLink>
        <NavLink path="/web-development">Web Development</NavLink>
        <NavLink path="/contact">Contact</NavLink>
      </TextMd>

      <div className='w-full flex justify-center items-center p-6 select-none'>
        <span>© 2026 Code-Contact</span>
      </div>
    </div>
  )
}
